<template>
  <a-layout class='index'>
    <a-card :bordered='false'>
      <a-form ref="ruleFormAddress" :model="addressForm" :rules="rulesAddress" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="name" label="收货人" name="name">
          <a-input v-model:value="addressForm.name" placeholder='请输入收货人姓名' />
        </a-form-item>
        <a-form-item ref="phone" label="手机号" name="phone">
          <a-input v-model:value="addressForm.phone" placeholder='请输入收货人手机号'   :maxlength="11" />
        </a-form-item>
        <a-form-item ref="province_id" label="收货地址" name="province_id">
          <a-cascader
            v-model:value="address"
            :field-names="{ label: 'name', value: 'id', children: 'children' }"
            :options="cityList"
            placeholder="请选择收货地址"
            @change="onChangeAddress"
          />
        </a-form-item>
        <a-form-item ref="detail" label="详细地址" name="detail" >
          <a-input v-model:value="addressForm.detail" placeholder='请输入详细地址' />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
          <a-button type="primary" @click="onSubmit" :loading="loading">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { orderAddressEdit } from "@/api/order";
  import { message } from 'ant-design-vue';
  import { getArea } from "@/api/public";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defForm = {
    id:'',
    name: '',
    phone: '',
    province_id:'',
    city_id:'',
    region_id:'',
    detail: '',
  }
  export default {
    name:'addressChange',
    components: {},
    props: {
      addressData: {
        type: Object
      }
    },
    setup(props,{ emit }) {
      //pass 
      const addressForm = ref({ ...defForm });

      const state = reactive({
        cityList:[],
        address:[],
        loading: false,
        labelCol: { span: 4 },
        wrapperCol: { span: 18 },
        rulesAddress: {
          name: [
            { required: true, message: '请输入收货人姓名' },
          ],
          phone: [
            {  validator: async (rule, value) => {
              if (!value) {
                return Promise.reject('请输入手机号');
              }
              var reg=/^1[0-9]{10}$/
              if (!reg.test(value)) {
                return Promise.reject('请输入完整的手机号');
              } 
        } },
          ],
          city: [
            { required: true, message: '请选择收货地址' },
          ],
          detail: [
            { required: true, message: '请输入详细地址' },
          ],
        }
      });
      const ruleFormAddress = ref()
      const _lodash = inject("_lodash");
      //获取省市区
      const getAreaList = async () => {
        let result = await getArea().then(res => res)
        state.cityList = result.data
      }
      getAreaList();
      //选择省市区
      const onChangeAddress = (e,options) => {
        addressForm.value.province_id = e[0]
        addressForm.value.city_id = e[1]
        addressForm.value.region_id = e[2]
        addressForm.value.city_texts = options[0].name+options[1].name+options[2].name
      }
      const onSubmit = () => {
        ruleFormAddress.value.validate().then(async() => {
          state.loading = true
          let res = await orderAddressEdit({...addressForm.value,detail:addressForm.value.city_texts+','+addressForm.value.detail}).then(res=>res.data).catch(error=>error)
          if (iscode(res)) {
            emit("submitaddress");
            message.success(res.msg);
          } else {
            message.error(res.msg);
          }
          state.loading = false
        })
        .catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        var addressData = props.addressData || {};
        addressForm.value = addressData;
        state.address = [addressData.province_id,addressData.city_id,addressData.region_id]
      });
      return {
        addressForm,
        ...toRefs(state),
        ruleFormAddress,
        onSubmit,
        getAreaList,
        onChangeAddress
      }
    }
  }
</script>
